// extracted by mini-css-extract-plugin
export var banner = "FaqSection-module--banner--3beb8";
export var content = "FaqSection-module--content--2b696";
export var registerBtn = "FaqSection-module--registerBtn--b30f1";
export var wrapper = "FaqSection-module--wrapper--0e201";